import React from "react";
import { SectionTop, SectionCards } from "../..";
import { getInvolvedSectionData } from "../../../assets/data/getInvolvedData";

export default function GetInvolvedSection() {
	return (
		<section className="no-px no-pb">
			<SectionTop
				heading="Be with us in all ways"
				description={
					<>Connect with us to make the world a better place</>
				}
				shrinkHeading
			/>

			<SectionCards data={getInvolvedSectionData} fullTextWidth />
		</section>
	);
}
